import { render, staticRenderFns } from "./ModalMsgVSA.vue?vue&type=template&id=804b5f14&"
import script from "./ModalMsgVSA.vue?vue&type=script&lang=js&"
export * from "./ModalMsgVSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports